import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccessAuthorizationHeaders } from "../../../api";
import { helpers } from "../../../packages/helpers";
import { getChatInfoData } from "../providers";
import { CHAT_ACTIONS } from "../types";
import type { ActionStoreParams } from "../../../store";
import type { ApiCallback } from "../../../packages/types";

const { getActionErrorText } = helpers.error;

type ActionReturn = ReturnType<typeof getChatInfoData>;

type ActionParams = {
  postChatInfoApi: ApiCallback;
};

export const postChatInfo = createAsyncThunk<
  ActionReturn,
  ActionParams,
  ActionStoreParams
>(CHAT_ACTIONS.POST_CHAT_INFO, async ({ postChatInfoApi }, { getState }) => {
  try {
    const headers = getAccessAuthorizationHeaders(getState());
    const resp = await postChatInfoApi({ headers });

    return getChatInfoData(resp);
  } catch (error) {
    const text = getActionErrorText(error);

    throw new Error(text);
  }
});
